export const NZENGO_TRANSFER_STATUSES = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const NZENGO_MEMBERSHIP_STATUSES = {
  ACTIVE: "ACTIVE",
  TRANSFERRED: "TRANSFERRED",
};

export const nzengoMockGroups = [
  {
    id: 101,
    name: "Mbagala Nzengo",
    group_category: "NZENGO",
    cycle_type: "PERMANENT",
    region: "Dar es Salaam",
    district: "Temeke",
    is_active: true,
  },
  {
    id: 102,
    name: "Mlimani Nzengo",
    group_category: "NZENGO",
    cycle_type: "PERMANENT",
    region: "Dar es Salaam",
    district: "Kinondoni",
    is_active: true,
  },
  {
    id: 103,
    name: "Kijitonyama Nzengo",
    group_category: "NZENGO",
    cycle_type: "PERMANENT",
    region: "Dar es Salaam",
    district: "Kinondoni",
    is_active: true,
  },
  {
    id: 104,
    name: "Arusha Mjini Nzengo",
    group_category: "NZENGO",
    cycle_type: "PERMANENT",
    region: "Arusha",
    district: "Arusha City",
    is_active: true,
  },
];

export const nzengoMockMembers = [
  {
    id: 501,
    fullName: "Salma Rashid",
    role: "Mwanachama",
  },
  {
    id: 502,
    fullName: "Amina Mbarak",
    role: "Mwanachama",
  },
];

export const initialNzengoMemberships = [
  {
    id: 801,
    memberId: 501,
    groupId: 101,
    status: NZENGO_MEMBERSHIP_STATUSES.ACTIVE,
  },
  {
    id: 802,
    memberId: 502,
    groupId: 101,
    status: NZENGO_MEMBERSHIP_STATUSES.ACTIVE,
  },
];

export const initialNzengoTransfers = [
  {
    id: 9001,
    memberId: 502,
    sourceGroupId: 101,
    destinationGroupId: 102,
    outstandingAmount: 0,
    status: NZENGO_TRANSFER_STATUSES.PENDING_APPROVAL,
    requestedAt: "2026-09-10T09:30:00.000Z",
  },
];
